module.exports = __webpack_public_path__ + "static/media/Melo-technologies.6da7b4ca.png";